import { IExtraContent } from '@dtos/Course'
import { IEnrollment } from '@dtos/Enrollment'
import {
  IContentAvailableProps,
  isContentAvailable,
  releaseContentDateText,
} from '@utils/contentAvailable'
import { ILessonExtraContentAvailability } from '@utils/lessonExtraContentAvailability'

type ExtraContentSchedule = Pick<
  IExtraContent,
  'releaseAt' | 'releaseAfter' | 'courseClassReleaseOffset'
>

type EnrollmentAnchor = Pick<IEnrollment, 'activatedAt' | 'courseClassRelease'>

/**
 * Disponibilidade de um material complementar do curso. "N dias após a
 * inscrição" conta da ativação da matrícula, como na aula e no core
 * (ExtraContent#available_for?); o createdAt do material não entra na conta.
 */
export function courseExtraContentAvailability(
  extraContent: ExtraContentSchedule,
  enrollment: EnrollmentAnchor | null | undefined,
): ILessonExtraContentAvailability {
  const props: IContentAvailableProps = {
    releaseAt: extraContent.releaseAt,
    releaseAfter: extraContent.releaseAfter,
    lockAt: null,
    lockAfter: null,
    createdAt: enrollment?.activatedAt ?? '',
    courseClassRelease: enrollment?.courseClassRelease,
    courseClassReleaseOffset: extraContent.courseClassReleaseOffset,
  }

  return {
    isAvailable: isContentAvailable(props),
    text: releaseContentDateText(props),
  }
}
